import useIsLoggedIn from "../../hooks/use-IsLoggedIn";
import Header from "../Profile/components/Header";
import ViewJob from "../StaticPages/HomePage/components/ViewJob";

function SpecificJobDetails() {
	const isLoggedIn = useIsLoggedIn();
	return (
		<div className="min-h-screen">
			{/*
			 * Header calls onChangeJobStatus unguarded for applicants, so it needs a handler
			 * even though this page has no job-status control of its own.
			 */}
			<Header isLoggedIn={isLoggedIn} onChangeJobStatus={() => {}} />
			{/* The only place ViewJob renders as a full page rather than inside a drawer. */}
			<ViewJob surface="job_details_page" />
		</div>
	);
}

export default SpecificJobDetails;
